"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDoubleQuotes = void 0;
/**
 * Sanitise strings in an object by removing double quotes.
 * - remove quotes from the signed data eg '"walup"' => 'walup'
 * @param obj The object to sanitize
 *
 * @returns The sanitized object
 */
const removeDoubleQuotes = (obj) => {
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        for (const subkey of Object.keys(value)) {
            if (typeof value[subkey] === 'string') {
                value[subkey] = value[subkey].replaceAll('"', '');
            }
        }
    }
    return obj;
};
exports.removeDoubleQuotes = removeDoubleQuotes;
//# sourceMappingURL=remove-double-quotes.js.map